import { targetParamMap } from '@smartproxy/sp-utils';

import { useApi } from '@/hooks/useApi';
import { useForm } from '@/hooks/useForm';

import Card from '@/decodo/components/atoms/Card';
import { filterObj, filterObjectByList } from '@/utils/objects';

import { ConfigForm } from './components/ConfigForm';
import { initFormValidatorForTarget, initFormValuesForTarget } from './helpers';
import { RequestResponse } from './RequestResponse';
import { useScraper } from './state/context';

export const ScraperMain = () => {
  const { target } = useScraper();

  const form = useForm<Record<string, string>>({
    initialValues: initFormValuesForTarget(target) as Record<string, string>,
    validator: initFormValidatorForTarget(target),
    validateOnChange: true,
  });

  const {
    data,
    error,
    loading: isScraping,
    makeApiCall: scrape,
  } = useApi({
    url: 'https://decodo.com/scraping/web/scraper-api',
    headers: { Origin: 'https://decodo.com/', 'x-target': target.name },
    method: 'POST',
  });

  const handleScrape = async (formState: Record<string, string>) => {
    const params = targetParamMap[target.name].filter(
      (param) =>
        param.group === 'primary' ||
        param.group === 'regular' ||
        param.key === 'parse'
    );
    const payload = filterObjectByList(
      formState,
      params.map((param) => param.key)
    );
    await scrape({
      body: {
        target: target.name,
        ...filterObj(payload, (value) => value !== null && value !== undefined),
      },
    });
  };

  return (
    <main className='z-0 flex flex-col gap-4 lg:h-[520px] lg:flex-row'>
      <Card
        roudnessLevel='s'
        classNames={{ root: 'flex-1 w-full lg:w-2/5 p-4 dark:border-gray-300' }}
      >
        <ConfigForm
          form={form}
          handleScrape={handleScrape}
          isScraping={isScraping}
        />
      </Card>
      <div
        className='h-[480px] md:h-[500px] lg:h-auto lg:w-3/5'
        style={{
          scrollbarColor: 'rgb(var(--color-gray-500)) transparent',
        }}
      >
        <RequestResponse form={form} response={data} error={error} />
      </div>
    </main>
  );
};
